import { BestForBrowsePagesOutput } from 'js/model/rainbow/BestForBrowsePagesOutput';
import { PropsType } from 'js/types/react';
import { CityBlocks } from 'js/components/CityBlocks';

export function createCityBlocksViewModelForBestForBrowse(
  bestForBrowsePages: BestForBrowsePagesOutput[]
): Pick<PropsType<CityBlocks>, 'cities'> {
  return {
    cities: bestForBrowsePages.map((page) => ({
      name: page.location,
      normalisedName: page.location,
      treatmentTypes: page.treatments.map((treatment) => ({
        name: treatment.name,
        uri: treatment.uri,
      })),
    })),
  };
}
